import { useState, useEffect } from 'react';
import './css/PurchaseOrderBottomSection.css';
import { PaymentOptions } from 'src/enums/PaymentOptions';
import { Util } from 'src/Util';
import moment from 'moment';

const PurchaseOrderBottomSection = (purchaseOrderData: any) => {
  const [purchaseOrderCurrency, setPurchaseOrderCurrency] = useState('');
  const [purchaseOrderValueWithDiscounts, setpurchaseOrderValueWithDiscounts] = useState<number>(0);
  const [updatedPurchaseOrderValue, setUpdatedPurchaseOrderValue] = useState<number>(0);
  let [purchaseOrderValueAfterCharge, setPurchaseOrderValueAfterCharge] =
    useState<number>(0);
  const [firstFieldAmount, setfirstFieldAmount] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [totalOustandingAmount, setTotalOustandingAmount] = useState<any>(null);
  const [creditSettleValues, setCreditSettleValues] = useState<any[]>([]);

  useEffect(() => {
    let totalValue = purchaseOrderData.purchaseOrderData?.subTotal;
    setUpdatedPurchaseOrderValue(totalValue);
    if (purchaseOrderData.purchaseOrderData?.discount > 0) {
      if (purchaseOrderData.purchaseOrderData?.discountType == 'PAYRATE') {
        setfirstFieldAmount(purchaseOrderData.purchaseOrderData?.discount);
        totalValue = totalValue - purchaseOrderData.purchaseOrderData?.discount;
      } else {
        setfirstFieldAmount(totalValue * (purchaseOrderData.purchaseOrderData?.discount / 100)
        );
        totalValue = totalValue - totalValue * (purchaseOrderData.purchaseOrderData?.discount / 100);
      }
    }

    setPurchaseOrderCurrency(purchaseOrderData.purchaseOrderData?.originalCurrency?.currencyName);
    setUpdatedPurchaseOrderValue(totalValue);

    setPurchaseOrderValueAfterCharge(totalValue);
    let finalPurchaseOrderValue = totalValue;


    if (purchaseOrderData.purchaseOrderData?.creditSettleValues != null) {
      setCreditSettleValues(purchaseOrderData.purchaseOrderData?.creditSettleValues);
    }

  }, [purchaseOrderData]);



  return (
    <>
      <div className="bottom-section-container">

        <div className="po-sec">
          <div className="po-sec1">Sub Total:</div>
          <div className="po-sec2">
            {Util.formatNumber(purchaseOrderData.purchaseOrderData?.subTotal)}{' '}
            {purchaseOrderCurrency}
          </div>
        </div>


        {purchaseOrderData.purchaseOrderData?.discount != null &&
          purchaseOrderData.purchaseOrderData?.discount != undefined &&
          purchaseOrderData.purchaseOrderData?.discount != 0 && (
            <>

              <div className="po-sec">
                <div className="po-sec1">
                  {purchaseOrderData.purchaseOrderData?.firstFieldType}{' '}
                  {purchaseOrderData.purchaseOrderData?.discountType != 'PAYRATE'
                    ? purchaseOrderData.purchaseOrderData?.discount + '%'
                    : ''}
                  :
                </div>
                <div className="po-sec2">
                  -{Util.formatNumber(firstFieldAmount)} {purchaseOrderCurrency}
                </div>
              </div>
            </>
          )
        }

        <div className="po-sec">
          <div className="po-sec1">
            <b>Total:</b>
          </div>
          <div className="po-sec2">
            <b>
              {Util.formatNumber(Math.abs(purchaseOrderValueAfterCharge))} {purchaseOrderCurrency}
            </b>
          </div>
        </div>

        <div className="seperate-line">
          <div className="sl"></div>
        </div>

        {purchaseOrderData.purchaseOrderData?.paymentOption != null &&
          purchaseOrderData.purchaseOrderData?.paymentOption == PaymentOptions.CASH &&
          (
            <>
              <div className="po-sec">
                <div className="po-sec1">
                  <b>Cash PO</b>
                </div>
                <div className="po-sec2"></div>
              </div>

              <div className="po-sec">
                <div className="po-sec1">Paid Amount</div>
                <div className="po-sec2">
                  {Util.formatNumber(purchaseOrderData.purchaseOrderData?.paidAmount)}{' '}
                  {purchaseOrderCurrency}
                </div>
              </div>

              <div className="po-sec">
                <div className="po-sec1">
                  <b>Balance</b>
                </div>
                <div className="po-sec2">
                  <b>
                    {Util.formatNumber(purchaseOrderData.purchaseOrderData?.balance)}{' '}
                    {purchaseOrderCurrency}
                  </b>
                </div>
              </div>
            </>
          )}

        {purchaseOrderData.purchaseOrderData?.paymentOption != null &&
          purchaseOrderData.purchaseOrderData?.paymentOption == PaymentOptions.CREDIT && (
            <>
              <div className="po-sec">
                <div className="po-sec1">
                  <b>Credit PO</b>
                </div>
                <div className="po-sec2"></div>
              </div>

              <div className="po-sec">
                <div className="po-sec1">Paid Amount</div>
                <div className="po-sec2">
                  {Util.formatNumber(purchaseOrderData.purchaseOrderData?.paidAmount)}{' '}
                  {purchaseOrderCurrency}
                </div>
              </div>

              <div className="po-sec">
                <div className="po-sec1">Outstanding</div>
                <div className="po-sec2">
                  <b>
                    {Util.formatNumber(
                      purchaseOrderData.purchaseOrderData?.outstandingAmount
                    )}{' '}
                    {purchaseOrderCurrency}
                  </b>
                </div>
              </div>

              {creditSettleValues && creditSettleValues.length > 0 && (
                <>
                  <div className="summary-sec" style={{ fontWeight: "bold", fontSize: "13px", color: "#989898", marginBottom: "0px" }}>
                    Credit Settlement History
                  </div>
                  {creditSettleValues
                    .sort((a, b) => {
                      const dateA = a.settledDate ? new Date(a.settledDate) : new Date(0);
                      const dateB = b.settledDate ? new Date(b.settledDate) : new Date(0);
                      return dateB.getTime() - dateA.getTime();
                    })
                    .map((entry, index) => {
                      let formattedDate = "Invalid Date";
                      if (entry.settledDate) {
                        if (typeof entry.settledDate === "string" || entry.settledDate instanceof Date) {
                          formattedDate = moment(entry.settledDate).format("D MMM YYYY");
                        } else if (typeof entry.settledDate === "object" && entry.settledDate.$date) {
                          formattedDate = moment(entry.settledDate.$date).format("D MMM YYYY");
                        }
                      }
                      return (
                        <div className="summary-sec-row" key={index}>
                          <div className="sub-sec1">{formattedDate}</div>
                          <div className="sub-sec3">
                            {Util.formatNumber(entry.settledAmount)} {purchaseOrderCurrency}
                          </div>
                        </div>
                      );
                    })}
                </>
              )}

              {totalOustandingAmount != null &&
                totalOustandingAmount != undefined &&
                totalOustandingAmount.summary && (
                  <>
                    <div className="summary-sec">Outstanding Bill Summary</div>

                    {totalOustandingAmount.summary.map((summary, index) => {
                      const formattedDate = moment(summary.createdAt).format(
                        'D MMM YYYY'
                      );
                      return (
                        <div className="summary-sec-row" key={index}>
                          <div className="sub-sec1">{formattedDate}</div>
                          <div className="sub-sec2">
                            {summary.purchaseOrderNumber}
                          </div>
                          <div className="sub-sec3">
                            {Util.formatNumber(summary.outstandingAmount)}{' '}
                            {purchaseOrderCurrency}
                          </div>
                        </div>
                      );
                    })}

                    <div className="po-sec">
                      <div className="po-sec1">Total Outstanding</div>
                      <div className="po-sec2">
                        <b>
                          {Util.formatNumber(
                            totalOustandingAmount.totalOutstandingAmount
                          )}{' '}
                          {purchaseOrderCurrency}
                        </b>
                      </div>
                    </div>
                  </>
                )}
            </>
          )}

        {purchaseOrderData.purchaseOrderData?.paymentOption != null &&
          purchaseOrderData.purchaseOrderData?.paymentOption == PaymentOptions.CHEQUE && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Cheque PO</b>
                </div>
                <div className="inv-sec2"></div>
              </div>
              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(purchaseOrderData.purchaseOrderData?.paidAmount)}{' '}
                  {purchaseOrderCurrency}
                </div>
              </div>
              <div className="inv-sec">
                <div className="inv-sec1">Cheque Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(purchaseOrderData.purchaseOrderData?.outstandingAmount)}{' '}
                  {purchaseOrderCurrency}
                </div>
              </div>
              {purchaseOrderData.purchaseOrderData?.chequeNo && (
                <div className="inv-sec">
                  <div className="inv-sec1">Cheque Number</div>
                  <div className="inv-sec2">
                    <b>{purchaseOrderData.purchaseOrderData?.chequeNo}</b>
                  </div>
                </div>
              )}
            </>
          )}


      </div>
    </>
  );
};

export default PurchaseOrderBottomSection;
